import React, { useCallback, useEffect, useState } from 'react';
import { PRIVACY, TERMS, USER_PROFILE, LOGIN } from '../../constants/routes';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getProfiles, getProfilePosts, getProfilePostsStats, getProfilePost } from '../../reducers/auth/auth.actions';


import { fetchProfile, fetchProfileSubs, toggleFollow, fetchProfileSubInfo } from '../../reducers/profile/profile.actions';
import { fetchFeed, deletePost, registeredCard } from 'reducers/feed/feed.actions';

import { useDispatch, useSelector } from 'react-redux';
import { getToken, setToken } from 'helpers';
import { getCurrentUser, loginUser } from 'reducers/auth/auth.actions';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import {
  DotsIcon,
  VerifiedIcon,
  CopyLinkIcon,
  GridIcon,
  GridContentIcon,
  DownArrow, HomeIcon, PlusCircleIcon, BellIcon, SubscriptionIcon,
  CloseModalIcon,
} from '../../components/Icons';
import { Button, Dropdown, ToggleButton } from 'react-bootstrap';
import BurgerMenu from '../../components/layout/BurgerMenu';

import {
  selectIsFetchingProfile,
  selectIsFollowingProfile,
  selectProfile,
  selectProfileLastActive,
} from '../../reducers/profile/profile.selectors';
import Loader from '../../components/Loader';
import { Helmet } from 'react-helmet';
import { appName } from '../../constants/const';
import Avatar from '../../components/Avatar';
import LastActiveBadge from '../../components/LastActiveBadge';
import moment from 'moment';
import useToggle from 'utils/customHooks/useToggle';
import Linkify from 'react-linkify';
import { selectFeed, selectIsFetchingFeed } from 'reducers/feed/feed.selectors';
import LinkedLockedContent from '../../views/profile/LinkedLockedContent';

const MAX_CHARS_POST_DESC = 40;

const LinkedProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);

  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [userPosts, setUserPosts] = useState(null);
  const [stats, setUserStats] = useState(null);
  const isHebrew = localStorage.getItem('current_language') === 'he';

  const [linkeProf, setLinkeProf] = useState(false);
  const [sidebar, setSidebar] = useState(false);

  const [subscribers, setSubscribers] = useState({});
  const [showCopyLink, setShowCopyLink] = useState(false);

  const [userInfo, setUserInfo] = useState(null);
  const [lastActive, setLastActive] = useState(null);

  const isFollowingProfile = useSelector(selectIsFollowingProfile);

  const [isLoading, setIsLoading] = useState(false);

  const [showFullDesc, setShowFullDesc] = useToggle();

  const isLong = user?.about?.length > MAX_CHARS_POST_DESC;




  useEffect(() => {


    dispatch(fetchProfileSubs(userId))
      .then(res => {
        setUserStats(res)


      })
      .catch(err => {

        console.log('fetch user error', err);
      });
    dispatch(getProfilePosts(userId))
      .then(res => {
        setUserPosts(res.data)


      })
      .catch(err => {

        console.log('fetch user error', err);
      });
    dispatch(getProfiles(userId))
      .then(res => {
        setUserInfo(res)
        setUser(res.user);
        setLastActive(res.last_active);

      })
      .catch(err => {

        console.log('fetch user error', err);
      });


    setLinkeProf(true)
  }, [userId]);

  const callback = useCallback((bar) => {
    setSidebar(bar);
  }, []);


  const FollowBtn = ({ style }) => {
    return (
      <Button
        className={'profile-sub-btn btn btn-light px-5 mt-0 ' + (isFollowingProfile ? '' : 'unfollowing')}
        style={{ width: '100%', borderRadius: '32px' }}
      >
        <span className="personal-profile-sub-icon profile-sub-icon">
          <SubscriptionIcon />
        </span>
        {t(isFollowingProfile ? 'Unsubscribe' : 'subscribe_to_see_post')}
      </Button>
    );
  };
  const MoreMenuBtn = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <DotsIcon style={{ transform: 'rotate(90deg)' }} fill="#fff" width={24}>
        {children}
      </DotsIcon>
    </div>
  ));


  const copyToClipboard = (user) => {
    let textField = document.createElement('textarea');
    textField.innerText = window.location.href.replace(window.location.pathname, '') + `/u/${user.id}/${user.nickname}`;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    setShowCopyLink(true);
    setTimeout(() => {
      setShowCopyLink(false);
    }, 2000);
  };
  return (
    <div className="main-layout-wrapper col profile-cont background_dark p-0">
      <div className="main-layout  container-fluid d-flex p-0 position-relative">
        <Loader isLoadin={!user} size={60}>
          {/* <div className={!!sidebar ? "visible-menu-toggle  container-fluid d-flex p-0 position-relative" : ' container-fluid d-flex p-0 position-relative'}> */}
          <div className={`linked-side-menu side-menu `}>
            <Link to={{
              pathname: LOGIN,
              state: { id: user && user.id, nick: user && user.nickname }
            }}> <HomeIcon /></Link>
            <BurgerMenu parentCallback={callback} linkedProfile={user && user} linkeProf={linkeProf} isHebrew={isHebrew} />




          </div>

          {/* </div> */}
          <div className="main-container w-100 offset-side-menu pt-0">
            <div className="col profile-cont p-0">

              {!!user && (
                <>
                  <Helmet>
                    <title>{appName + ' | ' + user.name}</title>
                  </Helmet>
                  <div
                    className="profile-header d-flex flex-column justify-content-between"
                    style={{
                      background: `linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%), url('${user.cover}')`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}
                  >
                    <div className="profile-head" style={{ paddingLeft: ' 0px' }}>
                      <div className="d-flex align-items-center" >
                        {/* <NewBackIcon onClick={clickHandler} /> */}
                        <div className={`ml-4 ${isHebrew ? "mr-2" : " "} `}>
                          <div className="d-flex align-items-center">
                            <h5 className="text-light-gray d-flex profile-head-user profile-head-user-wrap align-items-center m-0">
                              {user.name}
                            </h5>
                            {user.verification_status === "verified" && (
                              <VerifiedIcon height="1rem" width="1rem" className={`personal-page-verivication fill-white ${isHebrew ? "mr-2" : " "}`} style={{ transform: isHebrew ? 'rotate(00deg)' : 'rotate(0deg)' }} />
                            )}
                          </div>
                          <div className="d-flex align-items-center">
                            <h5 className="text-white m-0 mr-2 profile-head-info">
                              {user ? user.total_posts : 0} {t('posts')}
                            </h5>
                            <p className={`profile-dot mt-1 ${isHebrew ? "mr-1" : " "} `}></p>
                            <div className="d-flex profile-head-info ml-2">
                              <p className="profile-subscribers-amount">{subscribers ? subscribers.subscribing : 0}</p>
                              <p className={`profile-subscriber-text ${isHebrew ? "mr-1" : " "} `}>{`${stats && stats.likes} ${t('likes')}`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">



                      </div>
                    </div>
                  </div>
                  <div className=" col-md-9 col-12" style={{ marginTop: '-60px', padding: 0 }}>

                    <div className="d-flex flex-column" style={{ padding: '0 15px' }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ position: 'relative', top: '15px' }}
                      >
                        <Avatar
                          user={user && user.name}
                          size={96}
                          className="mb-2"
                          image={user.avatar}
                          style={{
                            backgroundSize: 'cover',
                            height: '96px',
                            width: '96px',
                            border: '2px solid #070E19',
                            borderRadius: '50px ',
                            fontSize: '30px',
                            left: '-9px',
                            top: '5px',
                          }}
                        >
                          <LastActiveBadge lastActive={lastActive} />
                        </Avatar>
                        <div className="d-flex align-items-center profile-actions-wrapper">

                          {/* <div className="profile-copy-link" onClick={() => copyToClipboard(user)}>
                            <CopyLinkIcon />
                          </div> */}
                        </div>
                      </div>
                      <h5 className="text-light-gray profile-head-user d-flex align-items-center mt-4">
                        {user.name}
                        {user.verification_status === "verified" && <VerifiedIcon height="1rem" width="1rem" className="fill-white personal-page-verivication" />}
                      </h5>
                      <div className="d-flex align-items-center">
                        <span className="mr-2 profile-head-displayname">{user.nickname ? `@${user.nickname}` : null}</span>
                        {/* <p className="profile-dot mr-2" style={{ backgroundColor: '#797f92' }}></p>
                  <span className="profile-head-displayname-last-een">
                    {t(`Last seen`)} {profileLastActive && moment(profileLastActive).fromNow()}
                  </span> */}
                      </div>
                      {user?.about && (
                        <>
                          <span className="post-description-wrapper" style={{ marginTop: '20px' }}>
                            <p
                              className={
                                'text-light-gray text-break post-description-wrapper-text ' +
                                ' ' +
                                (showFullDesc ? '' : 'ellipsis')
                              }
                            >
                              <Linkify>{showFullDesc ? user?.about : user?.about}</Linkify>
                            </p>
                          </span>
                          {isLong ? (
                            <span
                              className="post-description-btn d-flex align-items-center"
                              style={{ color: '#36CFFF' }}
                              onClick={setShowFullDesc}
                            >
                              {showFullDesc ? t('less_info') : t('more_info')}
                              {showFullDesc ? (
                                <DownArrow fill="#36CFFF" style={{ transform: 'rotate(180deg)', marginLeft: '14px' }} />
                              ) : (
                                <DownArrow fill="#36CFFF" style={{ marginLeft: '14px' }} />
                              )}
                            </span>
                          ) : null}
                        </>
                      )}
                      {user.website && (
                        <a
                          href={user.website.search(/^http[s]?\:\/\//) === -1 ? 'http://' + user.website : user.website}
                          target="_blank"
                          rel="noreferrer"
                          className="profile-website"
                        >
                          {user.website}
                        </a>
                      )}
                    </div>
                    <div style={{ position: 'relative', padding: '0 16.5px' }}>

                      <div className="subscription-box" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="subscription-box-line"></div>




                        <p className="mb-3 h5 text-center profile-sub-text">
                          {/* {user.subscriptionPrice > 0
                        ? t('Subscription ') + '$' + user.subscriptionPrice + t(' per month')
                        : isFollowingProfile
                        ? t('Subscribed')
                      : t('Subscription')} */}
                          {t('Subscription')}
                        </p>

                        <Link
                          className="burger-link text-light-gray cursor-pointer d-flex justify-content-between"
                          to={{
                            pathname: LOGIN,
                            state: { id: user.id, nick: user.nickname }
                          }}>
                          <Button
                            className={
                              'profile-sub-btn btn btn-light px-5 mt-0 ' + (isFollowingProfile ? 'followed-profile-sub' : 'unfollowing ')
                            }
                            style={{ width: '100%', borderRadius: '32px', color: '#00c2ffs' }}

                          >

                            <span className="personal-profile-sub-icon profile-sub-icon">
                              <SubscriptionIcon />
                            </span>

                            <div className="isFollowingProfile-action-wrap">
                              <span>{t('SUBSCRIBE')} </span>   {user.subscriptionPrice > 0 ? <span className="per-month">{'₪' + user.subscriptionPrice + " per month"}</span> : <span>{t('FOR FREE')}</span>}
                            </div>

                          </Button>
                        </Link>
                      </div>

                    </div>
                    <div className="profile-statistic-container">
                      <h5 className="m-0 mr-2 profile-head-info">
                        {userPosts && userPosts ? userPosts.length : 0}
                        <span>
                          {t('posts')}
                        </span>
                      </h5>
                      <div className="d-flex align-items-center">

                      </div>
                    </div>
                    <>
                      {userPosts && userPosts.length > 0 &&

                        userPosts.map((post, index) => (
                          <div key={index} className="profile-locked-content" style={{ padding: '0 15px' }}>

                            <React.Fragment>
                              <LinkedLockedContent
                                FollowBtn={FollowBtn}
                                MoreMenuBtn={MoreMenuBtn}
                                userStatus={userInfo.user.verification_status}
                                post={post}
                                files={post.files}
                              // card={card}
                              />
                            </React.Fragment>
                          </div>
                        ))}
                    </>
                  </div>


                </>)}
            </div>
          </div>
        </Loader>

      </div>
    </div>
  );
};

export default LinkedProfile;
